const updates = [
  { date: '07-28', title: '《斗罗大陆》第358话更新', tag: '热血', tagColor: 'text-primary-600 bg-primary-100' },
  { date: '07-28', title: '《完美世界》第296话更新', tag: '奇幻', tagColor: 'text-accent-600 bg-accent-100' },
  { date: '07-27', title: '《吞噬星空》第185话更新', tag: '科幻', tagColor: 'text-secondary-600 bg-secondary-100' },
  { date: '07-27', title: '《一念永恒》第243话更新', tag: '仙侠', tagColor: 'text-primary-600 bg-primary-100' },
  { date: '07-26', title: '《仙王的日常生活》第167话更新', tag: '搞笑', tagColor: 'text-accent-600 bg-accent-100' },
  { date: '07-26', title: '《大王饶命》第128话更新', tag: '热血', tagColor: 'text-primary-600 bg-primary-100' },
  { date: '07-25', title: '《全职高手》第312话更新', tag: '竞技', tagColor: 'text-secondary-600 bg-secondary-100' },
  { date: '07-25', title: '《全职猎人》最新话同步上线', tag: '经典', tagColor: 'text-accent-600 bg-accent-100' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最近更新</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">实时追踪热门漫画最新话更新动态</p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 py-3.5 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-background-100/50 rounded-lg px-3 -mx-3 transition-colors"
            >
              <span className="text-xs font-mono text-foreground-500 w-12 flex-shrink-0">{item.date}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium flex-shrink-0 ${item.tagColor}`}>{item.tag}</span>
              <span className="text-sm text-foreground-800 flex-1 hover:text-primary-600 transition-colors truncate">{item.title}</span>
              <span className="text-xs text-foreground-400 flex-shrink-0 hidden sm:inline">新</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}